export default {
      id: "icon-transcription-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "icons.svg#icon-transcription",
      toString: function () {
        return this.url;
      }
    }